export interface HotTopic {
  id: string;
  rank: number;
  title: string;
  category: string;
  heat: number;
  trend: "up" | "down" | "flat";
  board: "today" | "week";
  note: string;
}

export const hotTopics: HotTopic[] = [
  {
    id: "hot-01",
    rank: 1,
    title: "《长夜灯》双主角番位讨论",
    category: "影视",
    heat: 98210,
    trend: "up",
    board: "today",
    note: "官宣海报发布后两小时内讨论量翻了近三倍。",
  },
  {
    id: "hot-02",
    rank: 2,
    title: "NEON 成员调整传闻回应",
    category: "娱乐",
    heat: 90440,
    trend: "up",
    board: "today",
    note: "深夜回应没有给出具体安排，追问仍在继续。",
  },
  {
    id: "hot-03",
    rank: 3,
    title: "苏芮安巡演加场开票",
    category: "娱乐",
    heat: 86120,
    trend: "flat",
    board: "today",
    note: "三站同日开票，抢票提醒成了评论区高频词。",
  },
  {
    id: "hot-04",
    rank: 4,
    title: "联赛第 12 轮爆冷逼平",
    category: "体育",
    heat: 71500,
    trend: "up",
    board: "today",
    note: "补时丢球片段被反复剪辑传播。",
  },
  {
    id: "hot-05",
    rank: 5,
    title: "《星河夜话》剪辑顺序争议",
    category: "影视",
    heat: 63280,
    trend: "down",
    board: "today",
    note: "讨论热度在晚间冲高后回落，节目组尚未回应。",
  },
  {
    id: "hot-06",
    rank: 6,
    title: "星河科技随身设备预热",
    category: "科技",
    heat: 58940,
    trend: "up",
    board: "today",
    note: "定价猜测成了科技圈当日最热的话题之一。",
  },
  {
    id: "hot-07",
    rank: 1,
    title: "暑期档长尾逆袭盘点",
    category: "影视",
    heat: 152300,
    trend: "up",
    board: "week",
    note: "整周稳居榜首，中小成本作品讨论度持续走高。",
  },
  {
    id: "hot-08",
    rank: 2,
    title: "NEON 巡演计划公布",
    category: "娱乐",
    heat: 141870,
    trend: "flat",
    board: "week",
    note: "官方公布城市清单后，本周讨论量保持高位。",
  },
  {
    id: "hot-09",
    rank: 3,
    title: "开源版本迁移方案",
    category: "科技",
    heat: 112450,
    trend: "up",
    board: "week",
    note: "开发者社区连续多天在补充迁移清单。",
  },
  {
    id: "hot-10",
    rank: 4,
    title: "城市夜跑活动报名",
    category: "社会",
    heat: 87210,
    trend: "down",
    board: "week",
    note: "报名通道开启当天热度最高，随后平稳。",
  },
  {
    id: "hot-11",
    rank: 5,
    title: "暑期档音乐节交通提醒",
    category: "社会",
    heat: 76330,
    trend: "flat",
    board: "week",
    note: "出行提示类内容在周末前后明显升温。",
  },
];